/* Spin Digital menu final behaviour fix. Keeps the desktop navigation readable and out of Shopify's broken More overflow state. */
(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function fixMenu() {
    var header = document.querySelector('#header-component');
    if (!header) return;

    if (isMobile()) {
      header.dataset.menuStyle = 'drawer';
      return;
    }

    header.dataset.menuStyle = 'menu';

    var overflowLists = header.querySelectorAll('overflow-list, .spin-header-menu-list, .overflow-menu');
    overflowLists.forEach(function (list) {
      list.removeAttribute('minimum-reached');
      list.setAttribute('disabled', 'true');

      if (typeof list.showAll === 'function') {
        try { list.showAll(); } catch (e) {}
      }

      list.querySelectorAll('[slot="overflow"]').forEach(function (item) {
        item.removeAttribute('slot');
        item.removeAttribute('aria-hidden');
      });
    });
  }

  function ready() {
    fixMenu();
    requestAnimationFrame(fixMenu);
    setTimeout(fixMenu, 100);
    setTimeout(fixMenu, 350);
    setTimeout(fixMenu, 900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('overflow-list').then(ready).catch(function () {});
  }

  window.addEventListener('resize', function () {
    clearTimeout(window.__spinFinalMenuTimer);
    window.__spinFinalMenuTimer = setTimeout(fixMenu, 120);
  });
})();
